/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// gsap is available globally

(function() {
  function setupTabAnimations() {
    const tabContainers = document.querySelectorAll('.cmp-flindersonline-promotab-2');
    
    if (!tabContainers.length) return;
    
    tabContainers.forEach(container => {
      // Set up tab panel animations
      setupTabPanelAnimations(container);
      
      // Set up swipeable tablist
      setupSwipeableTabs(container);
    });
  }
  
  function setupTabPanelAnimations(container) {
    // Apply animation to initially active tab panel on page load
    const initialActivePanel = container.querySelector('.cmp-tabs__tabpanel--active');
    if (initialActivePanel) {
      const content = initialActivePanel.firstElementChild || initialActivePanel;
      
      // Set initial state for GSAP animation
      gsap.set(content, { 
        opacity: 0,
        y: 30
      });
      
      // Animate with GSAP with a slight delay for initial load
      setTimeout(() => {
        gsap.to(content, {
          opacity: 1,
          y: 0,
          duration: 0.4,
          ease: "power1.out"
        });
      }, 150);
    }

    // Use a MutationObserver to catch tab panel changes
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'class' && 
            mutation.target.classList.contains('cmp-tabs__tabpanel')) {
          
          const panel = mutation.target;
          
          // Check if panel just became active
          if (panel.classList.contains('cmp-tabs__tabpanel--active')) {
            const content = panel.firstElementChild || panel;
            
            // Set initial state with GSAP
            gsap.set(content, {
              opacity: 0,
              y: 50
            });
            
            // Animate with GSAP
            gsap.to(content, {
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: "power1.out",
            });
          }
          // Check if panel just became inactive
          else if (mutation.oldValue && mutation.oldValue.includes('cmp-tabs__tabpanel--active')) {
            const content = panel.firstElementChild || panel;
            
            // Slide out with GSAP (optional - might not be needed if hidden by tabs)
            gsap.to(content, {
              opacity: 0,
              y: 50,
              duration: 0.3,
              ease: "power1.in"
            });
          }
        }
      });
    });
    
    // Observe all tab panels for class changes
    const tabPanels = container.querySelectorAll('.cmp-tabs__tabpanel');
    
    tabPanels.forEach(panel => {
      observer.observe(panel, { 
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['class']
      });
    });
  }
  
  function setupSwipeableTabs(container) {
    const tablist = container.querySelector('.cmp-tabs__tablist');
    
    if (!tablist) return;
    
    // Wrap the tablist in a swiper container
    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper promotion-tabs-swiper';
    
    const swiperWrapperInner = document.createElement('div');
    swiperWrapperInner.className = 'swiper-wrapper';
    
    // Move each tab into a swiper slide
    const tabs = Array.from(tablist.querySelectorAll('[data-cmp-hook-tabs="tab"]'));
    tabs.forEach(tab => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(tab);
      swiperWrapperInner.appendChild(slide);
    });
    
    swiperWrapper.appendChild(swiperWrapperInner);
    
    // Replace the original tablist with the swiper
    tablist.parentNode.insertBefore(swiperWrapper, tablist);
    tablist.remove();
    
    // Add necessary styles
    const style = document.createElement('style');
    style.textContent = `
      .cmp-flindersonline-promotab-2 .promotion-tabs-swiper {
        width: 100%;
        overflow: visible;
      }
      
      .cmp-flindersonline-promotab-2 .promotion-tabs-swiper .swiper-wrapper {
        display: flex;
        align-items: center;
      }
      
      .cmp-flindersonline-promotab-2 .promotion-tabs-swiper .swiper-slide {
        width: auto;
        flex-shrink: 0;
      }
      
      .cmp-flindersonline-promotab-2 .cmp-tabs__tab {
        flex-shrink: 0 !important;
        white-space: nowrap !important;
        cursor: pointer;
      }
      
      .cmp-flindersonline-promotab-2 .cmp-tabs__tab:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    `;
    document.head.appendChild(style);
    
    // Initialize Swiper
    const swiper = new Swiper('.promotion-tabs-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      grabCursor: true,
      mousewheel: {
        releaseOnEdges: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 0,
        }
      }
    });
    
    // Handle tab clicks and ensure active tab is visible
    tabs.forEach(tab => {
      // Add click handler to ensure swiper navigation works
      tab.addEventListener('click', () => {
        // Find the slide containing this tab
        const slide = tab.closest('.swiper-slide');
        if (slide) {
          const slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
          // Slide to make the active tab visible
          swiper.slideTo(slideIndex, 300);
        }
      });
      
      // Remove focus when mouse leaves the tab
      tab.addEventListener('mouseleave', () => {
        tab.blur();
      });
    });
    
    // Also observe for tab activation to ensure active tab is scrolled into view
    observeTabActivationSwiper(container, swiper, tabs);
  }
  
  function observeTabActivationSwiper(container, swiper, tabs) {
    // Use MutationObserver to watch for tab activation
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'class' && 
            mutation.target.classList.contains('cmp-tabs__tab')) {
          
          const tab = mutation.target;
          
          // Check if this tab just became active
          if (tab.classList.contains('cmp-tabs__tab--active')) {
            // Find the slide containing this tab and slide to it
            const slide = tab.closest('.swiper-slide');
            if (slide) {
              const slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
              swiper.slideTo(slideIndex, 300);
            }
          }
        }
      });
    });
    
    // Observe all tabs for class changes
    tabs.forEach(tab => {
      observer.observe(tab, { 
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }
  

  
  // Run setup when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupTabAnimations);
  } else {
    setupTabAnimations();
  }
})();